<template>
    <div class="maps">
        <div class="spinner" v-if="loading">
            <div class="preload_spinner">
                <div class="preload_spinner_inside">
                    <div></div>
                </div>
            </div>
        </div>
        <div class="content" id="mapsContent" ref="mapsContent" v-else>
            <div
                v-for="map in maps"
                class="map-center"
                :key="map._id"
                :data-date="map.date"
                :data-downloads="map.downloads ? map.downloads : 0"
            >
                <div class="map">
                    <img :src="map.picture" class="image" :alt="map.name" />
                    <div>
                        <div class="top">
                            <div class="info">
                                <div class="title">{{ map.name }}</div>
                                <div class="author">
                                    By
                                    <router-link
                                        :to="{
                                            name: 'home',
                                            query: {
                                                id: map.user.id,
                                                ...(!!$parent.embedded
                                                    ? { embedded: true }
                                                    : {}),
                                            },
                                        }"
                                        tag="a"
                                    >
                                        {{ map.user.name }}</router-link
                                    >
                                </div>
                            </div>
                            <div class="buttons">
                                <router-link
                                    tag="button"
                                    :to="{
                                        name: 'edit-map',
                                        params: { id: map._id },
                                    }"
                                    class="edit button-blue"
                                >
                                    Edit
                                </router-link>
                                <button
                                    class="remove button-red"
                                    @dblclick="(e) => remove(e.target, map._id)"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                        <div class="description">{{ map.description }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import variables from "../../api/variables.json";
export default {
    name: "Dashboard",
    data() {
        return {
            loading: true,
            loadedMaps: [],
        };
    },
    computed: {
        token() {
            return this.$store.getters.token;
        },
        id() {
            return this.$store.getters.userId;
        },
        maps() {
            return this.loadedMaps;
        },
    },
    created() {
        this.getMaps();
    },
    mounted() {},
    methods: {
        getMapsPage(page, size, id = null) {
            let url = `${variables.host}/api/maps/meta?size=${size}&page=${page}`;
            if (id !== null) {
                url += "&user=" + id;
            }

            return fetch(url)
                .then((response) => response.json())
                .then((maps) => {
                    this.loadedMaps = [...maps, ...this.loadedMaps];
                    maps.forEach((currentMap) => {
                        console.log("Loading image: ", currentMap._id);
                        let pictureUrl = `${variables.host}/api/image/${currentMap._id}`;
                        fetch(pictureUrl)
                            .then((response) => {
                                return response.blob();
                            })
                            .then((image) => {
                                const urlImage = URL.createObjectURL(image);
                                const map = this.loadedMaps.find(
                                    (map) => map._id === currentMap._id
                                );
                                map.picture = urlImage;
                                this.$set(
                                    this.loadedMaps,
                                    this.loadedMaps.indexOf(map),
                                    map
                                );
                                console.log("Image loaded: ", currentMap._id);
                            });
                    });
                    return maps;
                })
                .catch((err) => {
                    console.log(err);
                    return err;
                });
        },
        getMapsPages(promise, page, size, id) {
            return promise
                .then(() => this.getMapsPage(page, size, id))
                .then((maps) => {
                    this.$nextTick(function() {
                        const selects = Object.keys(this.$refs)
                            .filter((x) => x.includes("-selected-version"))
                            .map((x) => this.$refs[x][0]);
                        selects.forEach((select) => {
                            if (select && select.childElementCount < 2) {
                                if (select) {
                                    return (select.style.display = "none");
                                } else {
                                    return "";
                                }
                            } else if (select) {
                                return (select.style.display = null);
                            } else {
                                return "";
                            }
                        });
                    });
                    if (maps.length < 1) return;
                    return this.getMapsPages(promise, page + 1, size, id);
                });
        },
        getMaps() {
            this.getMapsPages(Promise.resolve(), 0, 2, this.id).then(() => {
                this.loading = false;
            });
        },
        remove(button, id) {
            const map = button.closest(".map-center");
            fetch(`${variables.host}/api/map`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${this.token}`,
                },
                body: JSON.stringify({ id: id }),
            })
                .then((response) => {
                    if (response.status === 200) map.remove();
                    if (response.status === 401) {
                        this.$store.commit("setAuthentication", {
                            token: null,
                            userId: null,
                        });
                        this.$router.push({ name: "login" });
                    }
                })
                .catch(() => {});
        },
    },
};
</script>

<style scoped lang="scss" src="./assets/css/maps.scss"></style>
